import { Icon } from 'labstep-web/core/Icon';
import Segment, {
  type SegmentProps,
} from 'semantic-ui-react/dist/commonjs/elements/Segment';
import type { IconProps } from '../Icon/types';
import styles from './styles.module.scss';

export default ({
  children,
  onClose,
  ...rest
}: SegmentProps & {
  onClose?: IconProps['onClick'];
}) => (
  <Segment {...rest}>
    <div>
      {children}
      {onClose && (
        <Icon
          className={styles.closeIcon}
          name="times"
          onClick={onClose}
        />
      )}
    </div>
  </Segment>
);
